import { StrictMode, createRoot } from "@wordpress/element";
import SliderComercios from "./SliderComercios";

// Mount the component to the 'root' div
const roots = document.querySelectorAll('.slider-comercios-swiper');

roots.forEach((root) => {
  const perSlide = root.getAttribute('data-per-slide') || 3; // Example of getting a custom attribute
  createRoot(root).render(
    <StrictMode>
      <SliderComercios perSlide={parseInt(perSlide, 10)} />
    </StrictMode>
  );
});